import type { MerchantPreset } from './types';

/**
 * Merge merchant default copy beneath the integrator's `translations`.
 * Returns the original `translations` object when the preset has no strings so
 * downstream memoisation keeps a stable identity.
 */
export function mergeMerchantStrings(
  preset: Pick<MerchantPreset, 'strings'> | null | undefined,
  translations: Record<string, string> | null | undefined
): Record<string, string> | null | undefined {
  const presetStrings = preset?.strings;
  if (!presetStrings || Object.keys(presetStrings).length === 0) return translations;
  return { ...presetStrings, ...(translations ?? {}) };
}
